export const DEFAULT_EMAIL_FROM_NAME = "Award Party";

export function parseEmailFromAddress(from: string): {
  name: string | null;
  email: string;
} {
  const trimmed = from.trim();
  const angled = trimmed.match(/^(.+?)\s*<([^>]+)>$/);
  if (angled?.[1] && angled[2]) {
    const name = angled[1].trim().replace(/^["']|["']$/g, "");
    return { name: name || null, email: angled[2].trim() };
  }

  return { name: null, email: trimmed };
}

export function personFromAwardPartyDisplayName(
  name: string | null | undefined,
): string {
  const first = name?.trim().split(/\s+/)[0];
  if (!first) {
    return DEFAULT_EMAIL_FROM_NAME;
  }

  return `${first} from ${DEFAULT_EMAIL_FROM_NAME}`;
}

export const PRODUCT_SENDER_NAME = "Jose Tapizquent";
export const PRODUCT_EMAIL_FROM_NAME = personFromAwardPartyDisplayName(
  PRODUCT_SENDER_NAME,
);

export function formatResendFromAddress(
  fromEmail: string,
  displayName?: string | null,
): string {
  const parsed = parseEmailFromAddress(fromEmail);
  const name =
    displayName?.trim() || parsed.name || DEFAULT_EMAIL_FROM_NAME;
  return `${name} <${parsed.email}>`;
}
